<script>
	const _ = require('../../assets/js/_');

	component.exports = {
		data () {
			return {};
		},
		oninit () {
			if (!Ractive.isServer && !this.get('@shared.tuText')) {
				_.makeHTTPRequest({ url: 'https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/Terms%20of%20Use.md', rawResponse: true }).then((response) => {
					this.set('@shared.tuText', response);
				}).catch(() => {
					this.set('@shared.tuText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/jsdelivr/blob/master/Terms%20of%20Use.md`);
				});

				_.makeHTTPRequest({ url: 'https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/Privacy%20Policy.md', rawResponse: true }).then((response) => {
					this.set('@shared.ppText', response);
				}).catch(() => {
					this.set('@shared.ppText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/jsdelivr/blob/master/Privacy%20Policy.md`);
				});

				_.makeHTTPRequest({ url: 'https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/Sub-Processors.md', rawResponse: true }).then((response) => {
					this.set('@shared.spText', response);
				}).catch(() => {
					this.set('@shared.spText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/jsdelivr/blob/master/Sub-Processors.md`);
				});
			}
		},
	};
</script>
